import type { PlanResponse } from '../../shared/contracts.js';
import { formatDistance, formatDuration } from '../../shared/format.js';

/** One sub-trip's plan, or null while it has none that answers its current places and settings. */
export interface TourEntry {
  plan: PlanResponse | null;
}

/** The whole trip's figures: total distance and riding time over its sub-trips, or which one is still being planned. */
export function tourTotals(entries: TourEntry[]): { meters: number; seconds: number } | { planning: number } {
  const missing = entries.findIndex((entry) => entry.plan === null);
  if (missing >= 0) return { planning: missing + 1 };
  return {
    meters: entries.reduce((sum, entry) => sum + entry.plan!.route.distanceMeters, 0),
    seconds: entries.reduce((sum, entry) => sum + entry.plan!.route.timeSeconds, 0)
  };
}

/** "Whole trip: 812 km · 11 h 5 min", or "Planning sub-trip 2…" while one is missing. */
export function TourSummary({ entries, className }: { entries: TourEntry[]; className?: string }) {
  const totals = tourTotals(entries);
  return (
    <p className={className ?? 'tour-total'} role="status">
      {'planning' in totals ? `Whole trip: planning sub-trip ${totals.planning}…` : `Whole trip: ${formatDistance(totals.meters)} · ${formatDuration(totals.seconds)}`}
    </p>
  );
}
